import { useState, useEffect, ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { LightBoxWrapper } from './LightBoxWrapper';

/**
 * Copied from PropTypes in the original (non-Typescript) component. See comments there for documentation.
 */
interface LightBoxWrapperProps {
    fixed?: boolean,
    unMountHandler: () => void,
    closeLightbox?: boolean,
    frameless?: boolean,
    viewportPositioned?: boolean,
    additionalClasses?: string,
    children: ReactNode,
}

interface PortaledLightBoxWrapperProps extends LightBoxWrapperProps {
    /**
     * ID of a DOM element you want this component to be Portal'd out into
     */
    targetElementId: string,
}

/**
 * Like {@link LightBoxWrapper}, but wrapped in a Portal.
 *
 * "oh no, disaster, what a bad idea" - Eric Collins
 */
export const PortaledLightBoxWrapper = ({ targetElementId, ...forwardedProps }: PortaledLightBoxWrapperProps) => {
    const [containerElement, setContainerElement] = useState<HTMLElement | null>(null);

    // On mount, look for a container-element using targetElementId
    useEffect(() => {
        const maybeContainer = document.getElementById(targetElementId);
        if (!maybeContainer) {
            console.error(`Attempted to set up a Portaled LightBoxWrapper in '${targetElementId}' but no element with that ID exists`);
        } else {
            setContainerElement(maybeContainer);
        }
    }, [targetElementId]);

    if (!containerElement) {
        return null;
    }

    return createPortal(<LightBoxWrapper {...forwardedProps} />, containerElement);
};
